null


// WEBPACK FOOTER //
// https://raw.githubusercontent.com/scala-js/scala-js/v0.6.33/library/src/main/scala/scala/scalajs/concurrent/RunNowExcecutionContext.scala